//components/Common/Scrolling/BackToTop.jsx
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { Fab, Tooltip, Zoom } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const BackToTop = () => {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);

  const handleScroll = () => {
    setShow(window.scrollY > 300); 
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    window.scrollTo({
      top: 0,
      behavior: prefersReducedMotion ? "auto" : "smooth",
    });
  };

  return (
    <Zoom in={show}>
      <Tooltip title={t("tooltips.scrollToTop")}>
        <Fab
          color="primary"
          size="small"
          onClick={scrollToTop}
          sx={{
            position: "fixed",
            bottom: { xs: 72, sm: 32 },
            right: 16,
            zIndex: 1000,
            display: { xs: "flex", sm: "flex" },
          }}
          aria-label={t("tooltips.scrollToTop")}
        >
          <KeyboardArrowUpIcon />
        </Fab>
      </Tooltip>
    </Zoom>
  );
};

export default BackToTop;
